import { Heading, Paragraph, Popover } from '@zillow/constellation-10';

import { getListingStatusSuffix } from '../../../utils/clickstreamUtils';

import { emitSpecialOffersLearnMoreEvent, EVENT_IDS } from '../../../analytics/events/specialOffers';

import type { ZrmClickstreamUser } from '@zg-rentals/clickstream';
import type { GetUserPropertyDetailsResponseWebDto } from '@zg-rentals/ts-rental-manager-api-client';

type Props = {
  currentProperty: GetUserPropertyDetailsResponseWebDto;
  user: ZrmClickstreamUser;
  triggerLocation: string;
};

const InfoPopover = ({ triggerLocation, currentProperty, user }: Props) => {
  const handleOnOpen = () => {
    const triggerLocationSuffix = getListingStatusSuffix(
      currentProperty?.active,
      currentProperty?.lastActivatedMs?.toString() ?? '',
    );
    const triggerLocationWithListingSuffix = `${triggerLocation}${triggerLocationSuffix}`;
    emitSpecialOffersLearnMoreEvent({
      currentProperty,
      user,
      triggerLocation: triggerLocationWithListingSuffix,
    });
  };

  return (
    <Popover
      header={<Heading level={2}>Special offer</Heading>}
      body={
        <>
          <Paragraph>
            Special offers are deals or discounts you’re offering to prospective renters on your listing.
          </Paragraph>
          <br />
          <Paragraph>Example: Get $500 off first month’s rent when you sign by October 15.</Paragraph>
        </>
      }
      onOpenChange={(open) => open && handleOnOpen()}
      trigger={<Popover.Trigger data-eventid={EVENT_IDS.SPECIAL_OFFERS_LEARN_MORE} />}
    />
  );
};

export default InfoPopover;
